import React from 'react';

const PATHS = [
    "m 8.48937,189.38819 1.17469,-0.26375 m 0,0 4.22656,-0.97675 m 0,0 4.22657,-1.02179 4.22656,-1.06891 m 0,0 4.22656,-1.11819 4.22656,-1.16975 4.22657,-1.22369 4.22656,-1.28011 m 0,0 4.22656,-1.33914 4.22656,-1.40088 4.22657,-1.46547 4.22656,-1.53305 4.22656,-1.60373 4.22656,-1.67768 4.22657,-1.75504 4.22656,-1.83596 4.22656,-1.92061 4.22656,-2.00917 4.22657,-2.10181 4.22656,-2.19873 4.22656,-2.30011 4.22656,-2.40616 4.22657,-2.51711 4.22656,-2.63317 4.22656,-2.75458 4.22656,-2.88159 4.22657,-3.01446 4.22656,-3.15346 4.22656,-3.29886 4.22656,-3.45096 4.22657,-3.61009 4.22656,-3.77654 4.22656,-3.95068 4.22656,-4.13283 4.22657,-4.3234 4.22656,-4.52275 4.22656,-4.73129 4.22656,-4.94944 4.22657,-5.17766 4.22656,-5.41639 m 0,0 4.22656,-5.66614 4.22656,-5.9274 4.22657,-6.2007 4.22656,-6.48662 4.22656,-6.7857 4.22656,-7.09859 4.22657,-7.4259 4.22656,-7.7683 m 0,0 4.22656,-8.12648 4.22656,-8.5012 m 0,0 0.92214,-1.90622",
    "M 113.08856,8.21707 8.48937,189.38819",
    "m 217.68776,189.38819 -39.7477,-68.84503",
    "m 152.83626,77.06209 -39.7477,-68.84502",
    "M 83.80079,189.38819 H 217.68776",
];

export default function AxiomusLogo({ height = 36, className = '' }) {
    return (
        <svg
            height={height}
            viewBox="0 0 228 197"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            aria-label="Axiomus"
        >
            <defs>
                {/* Mask: white strokes = visible, rest hidden */}
                <mask id="axiomus-mask">
                    <g>
                        {PATHS.map((d, i) => (
                            <path key={i} d={d} fill="none" stroke="white"
                                strokeWidth="15" strokeLinecap="round"
                                strokeLinejoin="round" strokeMiterlimit="10" />
                        ))}
                    </g>
                </mask>
                <linearGradient id="axiomus-grad" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%"   stopColor="#0891b2" />
                    <stop offset="100%" stopColor="#7c3aed" />
                </linearGradient>
            </defs>
            {/* Gradient rect revealed through the logo mask */}
            <rect x="0" y="0" width="228" height="197"
                fill="url(#axiomus-grad)" mask="url(#axiomus-mask)" />
        </svg>
    );
}
